{
  "profileMenu": {
    "ariaLabel": "Open profile menu",
    "signOut": "Sign out",
    "errorMessage": "Sorry, we were unable to load your personalized information in the Bridge Bar.<br><br>You're not logged in, your session has timed out, or your browser may be blocking 3rd party cookies.",
    "loadingMessage": "We are attempting to load your user information.<br /><br />Thank you for your patience."
  },
  "applicationSwitcher": {
    "header": "Cox Automotive Solutions"
  },
  "orgContextSelector": {
    "onboardingPrompt": "Select your dealership to get started",
    "noMemberships": "No dealerships assigned",
    "loadError": "Unable to load dealerships",
    "searchPlaceholder": "Search dealerships",
    "searchPrompt": "Search for a dealership to get started",
    "searchMinLength": "Keep typing to search",
    "searchMaxLength": "Search is too long — shorten it",
    "searchLoading": "Searching…",
    "searchNoResults": "No dealerships match your search",
    "searchError": "Unable to search dealerships",
    "searchRetry": "Try again"
  },
  "sideNav": {
    "ariaLabel": "Open side navigation menu",
    "menuLabel": "Menu",
    "dashboardLabel": "Dashboards",
    "productUpdatesLabel": "Product Updates",
    "railAriaLabel": "Side navigation",
    "chevronShowMore": "Show more navigation items",
    "chevronBackToTop": "Back to top",
    "menuTitle": "Menu",
    "menuClose": "Close menu"
  }
}
